import { Download } from "lucide-react";
import { useState } from "react";
import { useMailPwaInstall } from "@/hooks/useMailPwaInstall";

/** Bouton header — icône téléchargement + libellé (SpeedEats). */
export function MailPwaInstallButton() {
  const pwa = useMailPwaInstall();
  const [busy, setBusy] = useState(false);
  const [showIosHint, setShowIosHint] = useState(false);

  if (!pwa.showInstallUi) return null;

  const label = busy ? "Installation…" : "Installer Aurélia Mail";

  async function handleClick() {
    if (pwa.canNativeInstall) {
      setBusy(true);
      setShowIosHint(false);
      try {
        await pwa.install();
      } finally {
        setBusy(false);
      }
      return;
    }
    if (pwa.isIos) {
      setShowIosHint(true);
    }
  }

  return (
    <div className="mail-pwa-install-wrap">
      <button
        type="button"
        className="mail-pwa-install-btn"
        onClick={() => void handleClick()}
        disabled={busy}
        title={label}
        aria-label={label}
      >
          <Download className="mail-pwa-install-btn__icon" aria-hidden />
          <span className="mail-pwa-install-btn__label">{label}</span>
      </button>
      {showIosHint && pwa.isIos && !pwa.canNativeInstall ? (
        <p className="mail-pwa-install-hint">
          Sur iPhone : <strong>Partager</strong> → <strong>Sur l&apos;écran d&apos;accueil</strong>
        </p>
      ) : null}
    </div>
  );
}
